// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"AdminProvisionsView-module__badgeWrapper--wge1I","addNewWrapper":"AdminProvisionsView-module__addNewWrapper--svOcM"};